import { RootState } from 'src/store';

import { IPaymentHistoryItemData, IPaymentOrderListData } from './types';

export const selectPaymentOrdersData = (state: RootState): Partial<IPaymentOrderListData> => state.paymentOrders.list.data;
export const selectPaymentOrdersLoading = (state: RootState): boolean => state.paymentOrders.list.isLoading;
export const selectPaymentOrdersLoaded = (state: RootState): boolean => state.paymentOrders.list.isLoaded;
export const selectPaymentOrderItemData = (state: RootState): Partial<IPaymentHistoryItemData> => state.paymentOrders.item.data;
export const selectPaymentOrderItemLoading = (state: RootState): boolean => state.paymentOrders.item.isLoading;
export const selectPaymentOrderItemLoaded = (state: RootState): boolean => state.paymentOrders.item.isLoaded;
